/**
 * #mention.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../typeRegistry.js";
import { UserV2 } from "./userv2.js";
function createBaseMentions() {
    return { items: [] };
}
export const Mentions = {
    $type: "devvit.reddit.v2alpha.Mentions",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.items) {
            Mention.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMentions();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.items.push(Mention.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { items: globalThis.Array.isArray(object?.items) ? object.items.map((e) => Mention.fromJSON(e)) : [] };
    },
    toJSON(message) {
        const obj = {};
        if (message.items?.length) {
            obj.items = message.items.map((e) => Mention.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return Mentions.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMentions();
        message.items = object.items?.map((e) => Mention.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(Mentions.$type, Mentions);
function createBaseMention() {
    return { user: undefined, params: undefined };
}
export const Mention = {
    $type: "devvit.reddit.v2alpha.Mention",
    encode(message, writer = _m0.Writer.create()) {
        if (message.user !== undefined) {
            UserV2.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        if (message.params !== undefined) {
            MentionParameters.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMention();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = UserV2.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.params = MentionParameters.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            user: isSet(object.user) ? UserV2.fromJSON(object.user) : undefined,
            params: isSet(object.params) ? MentionParameters.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = UserV2.toJSON(message.user);
        }
        if (message.params !== undefined) {
            obj.params = MentionParameters.toJSON(message.params);
        }
        return obj;
    },
    create(base) {
        return Mention.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMention();
        message.user = (object.user !== undefined && object.user !== null) ? UserV2.fromPartial(object.user) : undefined;
        message.params = (object.params !== undefined && object.params !== null)
            ? MentionParameters.fromPartial(object.params)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(Mention.$type, Mention);
function createBaseMentionParameters() {
    return { raw: "", args: [] };
}
export const MentionParameters = {
    $type: "devvit.reddit.v2alpha.MentionParameters",
    encode(message, writer = _m0.Writer.create()) {
        if (message.raw !== "") {
            writer.uint32(10).string(message.raw);
        }
        for (const v of message.args) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMentionParameters();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.raw = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.args.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            raw: isSet(object.raw) ? globalThis.String(object.raw) : "",
            args: globalThis.Array.isArray(object?.args) ? object.args.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.raw !== "") {
            obj.raw = message.raw;
        }
        if (message.args?.length) {
            obj.args = message.args;
        }
        return obj;
    },
    create(base) {
        return MentionParameters.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMentionParameters();
        message.raw = object.raw ?? "";
        message.args = object.args?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(MentionParameters.$type, MentionParameters);
function isSet(value) {
    return value !== null && value !== undefined;
}
